<template>
  <transition name="loading-fade">
    <div
      v-if="isLoading"
      class="loading-overlay">
      <div class="loading-overlay__spinner">
        <div class="loading-overlay__dot" />
        <div class="loading-overlay__dot" />
        <div class="loading-overlay__dot" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LoadingOverlay',
  computed: {
    ...mapGetters({
      isLoading: 'loading/isLoading'
    })
  }
};
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: calc(100% - 73px);
  height: 100vh;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);

  &__spinner {
    display: flex;
    gap: 8px;
  }

  &__dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #20a052;
    animation: loading-bounce 1.2s infinite ease-in-out;

    &:nth-child(2) {
      animation-delay: 0.15s;
    }

    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }
}

@keyframes loading-bounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: opacity 0.25s ease;
}

.loading-fade-enter,
.loading-fade-leave-to {
  opacity: 0;
}
</style>
